import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';

import { RoleService, UserRole } from '@app/security/data-access/role/role.service';
import { HankoAuthService } from '@app/security/feature/hanko/data-access/hanko-auth.service';

/**
 * Decyduje, na jaką stronę przekierować po wejściu na `/redirect` lub `/`.
 */
export const RedirectGuard: CanActivateFn | CanActivateChildFn = () => {
  const router = inject(Router);
  const hankoAuthService = inject(HankoAuthService);
  const roleService = inject(RoleService);

  if (!hankoAuthService.isAuthenticated()) {
    return router.parseUrl('/auth/sign-in');
  }

  if (roleService.hasRole(UserRole.SuperAdmin)) {
    return router.parseUrl('/facilities');
  }
  if (roleService.hasRole(UserRole.FacilityAdmin)) {
    return router.parseUrl('/patients');
  }
  if (roleService.hasRole(UserRole.Therapist)) {
    return router.parseUrl('/patients');
  }

  return router.parseUrl('/errors/404');
};
